import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  dataline: (invalid: boolean, isDragging: boolean) => (theme: Theme) => ({
    position: 'relative',
    opacity: isDragging ? 0.2 : 1,
    overflow: 'hidden',
    border: `2px solid ${theme.colors.neutral[200]}`,
    borderRadius: '0.25rem',
    borderColor: invalid ? theme.colors.error[600] : theme.colors.neutral[200],
  }),

  header: {
    py: 0.5,
    alignItems: 'center',
  },

  formWrapper: {
    flexGrow: 1,
    py: 0.5,

    form: {
      height: '100%',
    },
  },

  closeButton: {
    // Ensure the close button is clickable when dataline is locked
    position: 'relative',
    zIndex: 2,
  },

  inputWrapper: (theme: Theme) => ({
    position: 'relative',
    height: '100%',
    flexGrow: 1,
    alignItems: 'center',

    input: {
      height: '100%',
      width: '100%',
      pr: '2rem',
      border: `none`,
      borderRadius: '0.25rem',

      '&:focus': {
        border: `1px solid ${theme.colors.neutral[200]}`,

        '+ button': {
          visibility: 'visible',
        },
      },
    },

    button: {
      // add a delay to make it possible to click the button before being hidden
      transition: 'visibility 0s .1s',
      visibility: 'hidden',
    },
  }),

  resetInputButton: {
    position: 'absolute',
    right: 0,
    top: '-0.25rem',
  },

  datalineLocked: (theme: Theme) => ({
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    justifyContent: 'center',
    backgroundColor: alpha(theme.colors.neutral[600], 0.5),
  }),

  largeLock: {
    height: '7rem',
    width: 'auto',
  },
};
